import React from "react";
import ReactDOM from "react-dom";
import EmployeesPage from "../components/EmployeesPage";
import { displayActiveEmployees } from "./display-active-employees";
import { addContextLog } from "../../../infrastructure/log";
import { setPageOnboarding } from "../../../infrastructure/user-onboarding-client";

export function renderEmployeesPage() {
  ReactDOM.render(<EmployeesPage />, document.getElementById("page-container"));
}

export function displayEmployeesPage(currentPage) {
  renderEmployeesPage();
  addContextLog("info", "displayEmployeesPage", "display-screen");
  displayActiveEmployees(currentPage);
  setPageOnboarding();
}
